import React from "react";

export const LinkIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="20"
        viewBox="0 0 19 20"
        fill="none">
        <path
          d="M9.17525 4.99L11.4993 2.667C12.2065 1.9598 13.1656 1.5625 14.1658 1.5625C14.661 1.5625 15.1513 1.66004 15.6089 1.84955C16.0664 2.03906 16.4821 2.31683 16.8323 2.667C17.1824 3.01717 17.4602 3.43288 17.6497 3.8904C17.8392 4.34792 17.9368 4.83829 17.9368 5.3335C17.9368 5.82872 17.8392 6.31908 17.6497 6.7766C17.4602 7.23412 17.1824 7.64983 16.8323 8L14.5093 10.324M4.48925 9.677L2.16525 12C1.45792 12.7073 1.06055 13.6667 1.06055 14.667C1.06055 15.6673 1.45792 16.6267 2.16525 17.334C2.87259 18.0413 3.83194 18.4387 4.83225 18.4387C5.83257 18.4387 6.79192 18.0413 7.49925 17.334L9.82225 15.01M11.4973 8L7.49725 12"
          stroke="black"
          stroke-width="2"
          stroke-linecap="square"
        />
      </svg>
    </div>
  );
};
